import React, { useState, useEffect } from 'react';
import api from '../api';
import { format } from 'date-fns';

export const Payouts = () => {
  const [payouts, setPayouts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => { fetch(); }, [statusFilter]);

  const fetch = async () => {
    setLoading(true);
    try {
      const params = statusFilter ? `?status=${statusFilter}` : '';
      const res = await api.get(`/admin/payouts${params}`);
      setPayouts(res.data.data?.payouts || []);
    } catch (err) {
      console.error(err);
      setPayouts([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 className="page-title">Payout History</h1>
      <div className="glass">
        <div className="card-header">
          <div className="action-bar" style={{ margin: 0 }}>
            <select className="dropdown" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
              <option value="">All Statuses</option>
              <option value="SCHEDULED">Scheduled</option>
              <option value="PROCESSING">Processing</option>
              <option value="COMPLETED">Completed</option>
              <option value="FAILED">Failed</option>
            </select>
          </div>
        </div>
        <div className="table-container" style={{ border: 'none', borderRadius: '0 0 16px 16px' }}>
          {loading ? (
            <div className="loader-container"><div className="spinner"></div></div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Recipient</th>
                  <th>Circle</th>
                  <th>Round</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Scheduled</th>
                  <th>Completed</th>
                </tr>
              </thead>
              <tbody>
                {payouts.map(p => (
                  <tr key={p.id}>
                    <td style={{ fontWeight: 500 }}>
                      {p.recipient ? `${p.recipient.firstName} ${p.recipient.lastName}` : '—'}
                      <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{p.recipient?.email}</div>
                    </td>
                    <td>{p.circle?.name || '—'}</td>
                    <td>{p.round}</td>
                    <td style={{ fontWeight: 600 }}>${Number(p.amount).toLocaleString()}</td>
                    <td>
                      <span className={`badge ${(p.status || 'scheduled').toLowerCase()}`}>{p.status}</span>
                    </td>
                    <td style={{ color: 'var(--text-secondary)' }}>
                      {p.scheduledDate ? format(new Date(p.scheduledDate), 'MMM dd, yyyy') : '—'}
                    </td>
                    <td style={{ color: 'var(--text-secondary)' }}>
                      {p.completedAt ? format(new Date(p.completedAt), 'MMM dd, yyyy') : '—'}
                    </td>
                  </tr>
                ))}
                {payouts.length === 0 && (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center', padding: 32, color: 'var(--text-secondary)' }}>
                      No payouts to show
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};
